import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as helpAction from '../action/helpAction';
import * as guideAction from '../action/guideAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

//Func
import { lsNavigatiorConditionInit } from '../func/lsNavigatiorCondition';


class Comp extends React.Component {
  constructor(props) {
    super(props);
    if (!localStorage.getItem('NavigatiorCondition')) {
      lsNavigatiorConditionInit();
    }
    let lsObj = JSON.parse(localStorage.getItem('NavigatiorCondition'));
    this.state = {
      navigatiorVisible: lsObj.visible,
      mainPhotoDialog: false,
    }

  }



  _navigatiorConditionSet(value) {
    var obj = {
      visible: value,
    };
    localStorage.setItem('NavigatiorCondition', JSON.stringify(obj));
    this.setState({navigatiorVisible: value});
  }

	render() {
    let stopComp;
    let profileComp;
    let proofComp;
    let emailComp;
    //let photoMainComp;
    //let webPushComp;
    let requiredCount = 0;
    //let optionalCount = 0;
    let comp;

    if (this.props.my.setting.serviceStop === 1) {
      requiredCount++;
      stopComp = (
        <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
          <div style={{padding:'10px'}}>
            <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>サービスが停止中です</div>
            <div>
              現在サービスが停止中の為、プロフィールが非公開です。
            </div>
            <div align='right'>
              <Link to={{ pathname: '/setting/stop/'}}>
                <Button
                  variant="contained"
                  color="primary"
                >
                  再開はこちら
                </Button>
              </Link>
            </div>
          </div>
        </Box>
      )
    }
    else if ( this.props.my.setting.profileWebmasterCheck === 0 && this.props.my.request.profile === 0) {
      requiredCount++;
      profileComp = (
        <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
          <div style={{padding:'10px'}}>
            <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>プロフィールのコメントが未登録です</div>
            <div align='right'>
              <Link to={{ pathname: '/my/comment/'}}>
                <Button
                  variant="contained"
                  color="primary"
                >
                  プロフィールのコメントを編集
                </Button>
              </Link>
            </div>
          </div>
        </Box>
      )
    }
    else {
      if (this.props.my.proof.person === 0　&& this.props.my.proof.credit === 0 && this.props.my.request.proof.person === 0) {
        requiredCount++;
        proofComp = (
          <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
            <div style={{padding:'10px'}}>
              <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>本人証明が申請されていません</div>
              {
                (this.props.my.profile.userdata_sex === 'men') ? (
                  <div>
                    本人証明を申請いただくと無料で<span className='link' onClick={ () => this.props.guideApproachMailSet(true) }><u>アプローチメール</u></span>が送信できます。
                  </div>
                ): (
                  <div>
                    本人証明を申請いただくと<span className='link' onClick={ () => this.props.guidePaymentSet(true, 'women') }><u>すべて無料</u></span>でご利用いただけます。
                  </div>
                )
              }
              <div align='right'>
                <Link to={{ pathname: '/my/proof/person'}}>
                  <Button
                    variant="contained"
                    color="secondary"
                  >
                    本人証明を申請する
                  </Button>
                </Link>
              </div>
            </div>
          </Box>
        )
      }
      if (!this.props.my.setting.email) {
        requiredCount++;
        emailComp = (
          <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
            <div style={{padding:'10px'}}>
              <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>メールアドレスが未登録です</div>
              <div>
                未登録だとログインできない時などの大切なお知らせが送信できません。
              </div>

              <div align='right'>
                <Link to={{ pathname: '/setting/email/'}}>
                  <Button
                    variant="contained"
                    color="primary"
                  >
                    メールアドレスの登録
                  </Button>
                </Link>
              </div>
            </div>
          </Box>
        )
      }

    }

    if (requiredCount > 0) {
      comp = (
        <div>
          { stopComp }
          { profileComp }
          { proofComp }
          { emailComp }
        </div>
      )
    }
    /*
    else if (optionalCount > 0) {
      comp = (
        <div>
            <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
              <Grid
                item
              >
                <h3>使い方ナビ</h3>
              </Grid>
              <Grid item  style={{position:"relative"}}>

                  <Switch
                    onChange={ (event) => this._navigatiorConditionSet(event.target.checked) }
                    checked={ this.state.navigatiorVisible }
                  />
                  {
                    (this.state.navigatiorVisible === false) && (
                      <span style={{position:'absolute',top:'3px',right:'6px'}}>
                        <span className='badge'> </span>
                      </span>
                    )
                  }
              </Grid>
            </Grid>




          <Collapse in={this.state.navigatiorVisible}>
            <div>

              { photoMainComp }
              { webPushComp }
            </div>
          </Collapse>
        </div>
      )
    }
    */
		return (
			<div id='navigator_block' className={this.props.className}>
        { comp }
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
